<template>
    <div>
        <div class="selected-chips">
            <p v-for="select in selectedCommunities" :key="select" >{{select}}<a @click="deleteCommunity(select)">&times;</a></p>
        </div>
            
        <div class="input-group mt-2 position-relative mb-2 d-flex"  ref="inputName">           
            <div class="input-group-prepend">
                <span class="input-group-text bg-primary text-white border-light">
                    <i class="fas fa-search"/>
                </span>
            </div>
            <input type="text" class="form-control" placeholder="Name" v-model="community" @input="search" @click="search">
            <div class="preloader" v-if="preloader">
                <div class="dot-pulse"></div>
            </div> 
            <div class="input-group-append cursor-pointer" v-if="bookmarkButton" @click="$emit('bookmarks')">
                <span class="input-group-text bg-primary text-white border-light book-ic" :class="{active:isBookmarks}"><i class="fa fa-bookmark"/></span>
            </div>
            <ul class="position-absolute communities"
                v-if="openDropdown" ref="dropdown"
            >
                <li v-for="loc in communities" :key="loc.id" @click="selectLoc(loc)">{{loc.name}}</li>
            </ul>
        </div>
    </div>
</template>

<script>
import { searchByName } from '../../api'
export default {
    name: 'Multiselect',
    data() {
        return {
            community: '',
            communities: [],
            selectedCommunities: [],
            preloader: false,
            bookmarkButton: false,
            openDropdown: false
        } 
    },
    methods: {
        async search () {
            this.preloader = true
            this.openDropdown = true
            if (this.community !== '') {
                if(this.selectedCommunities.length) {
                    const resp = await searchByName(this.community)
                    this.communities = resp.filter(el => !this.selectedCommunities.includes(el.name))
                } else {
                    this.communities = await searchByName(this.community)
                }
                this.preloader = false
            } else {
                this.communities = []
                this.preloader = false
                // this.selectLoc('')
            }
        },
        selectLoc (loc) {
            if (this.community !== '') {
                this.startSearch = false
                this.selectedCommunities.push(loc.name)
                this.communities = []
                this.filter()
                this.community = ''
            }
        },
        filter() {
            this.$emit('filter', {
                name: this.selectedCommunities
            })
        },
        deleteCommunity (select) {
            this.selectedCommunities = this.selectedCommunities.filter(el => el !== select)
            this.filter()
        },
        closeDropdown(e) {
            const el = this.$refs.dropdown;
            const input = this.$refs.inputName;
            const target = e.target;

            if ((el && el !== target && !el.contains(target)) &&
                (input && input!== target && !input.contains(target))) {
                this.openDropdown = false;       
            }
        },
    },
    created() {
        document.addEventListener('click', this.closeDropdown);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.closeDropdown);
    },
}
</script>

<style scoped lang="scss">
    .form-control{
        &:focus{
            box-shadow: none;
        }
    }
    .input-group-prepend{
        border: 1px solid #ced4da;
        border-radius: 0.25rem 0 0 0.25rem;
    }
    .preloader{
        position: absolute;
        left: 50%;
        top: 40%;
        transform: translate(-50%);
        z-index: 3;
    }

    .dot-pulse {
        position: relative;
        left: -9999px;
        width: 10px;
        height: 10px;
        border-radius: 5px;
        background-color: #ff9a22;
        color: #ff9a22;
        box-shadow: 9999px 0 0 -5px #ff9a22;
        animation: dotPulse 1.5s infinite linear;
        animation-delay: .25s;
    }

    .dot-pulse::before, .dot-pulse::after {
    content: '';
        display: inline-block;
        position: absolute;
        top: 0;
        left: 0;
        width: 10px;
        height: 10px;
        border-radius: 5px;
        background-color: #ff9a22;
        color: #ff9a22;
    }

    .dot-pulse::before {
        box-shadow: 9984px 0 0 -5px #ff9a22;
        animation: dotPulseBefore 1.5s infinite linear;
        animation-delay: 0s;
    }

    .dot-pulse::after {
        box-shadow: 10014px 0 0 -5px #ff9a22;
        animation: dotPulseAfter 1.5s infinite linear;
        animation-delay: .5s;
    }

    @keyframes dotPulseBefore {
        0% {
            box-shadow: 9984px 0 0 -5px #ff9a22;
        }
        30% {
            box-shadow: 9984px 0 0 2px #ff9a22;
        }
        60%,
        100% {
            box-shadow: 9984px 0 0 -5px #ff9a22;
        }
    }

    @keyframes dotPulse {
        0% {
            box-shadow: 9999px 0 0 -5px #ff9a22;
        }
        30% {
            box-shadow: 9999px 0 0 2px #ff9a22;
        }
        60%,
        100% {
            box-shadow: 9999px 0 0 -5px #ff9a22;
        }
    }

    @keyframes dotPulseAfter {
        0% {
            box-shadow: 10014px 0 0 -5px #ff9a22;
        }
        30% {
            box-shadow: 10014px 0 0 2px #ff9a22;
        }
        60%,
        100% {
            box-shadow: 10014px 0 0 -5px #ff9a22;
        }
    }
    .selected-chips{
        display: flex;
        max-width: 100%;
        flex-wrap: wrap;
        align-items: stretch;
        align-content: stretch;
        margin-top: 0.5rem ;
        p{
            border-radius: 50px;
            border: 1px solid #fff;
            padding: 0 5px 0 10px;
            margin: 2px;
            background: #ff9a22;
            color: #fff;
            a{
                margin-left: 5px;
                cursor: pointer;
            }
        }
    }
    .communities {
        width: 100%;
        top: 40px;
        color: #000;
        background-color: #fff;
        list-style-type: none;
        padding: 0;
        border-radius: 3px;
        z-index: 3;
        max-height: 360px;
        overflow-y: scroll;
        li {
            padding: 5px 10px;
            cursor: pointer;
        }
    }
</style>